import React from 'react'
import s from './loading.module.scss'

export default function Loading() {
  return (
    <div className={s.loading}>
      <div className={s.block}>
          <h3 className={s.top}>
             Tasnif <br />
            <span> bu</span>
          </h3>
          <h3 className={s.medium}>O'zgacha</h3>
          <h3 className={s.bottom}>Did <br /> Dizayn</h3>
      </div>
      </div>
  )
}
